import { getApi } from "@/utils/fetch";
import { ReferralSourceResponse } from "@/utils/referralSource";

const fetchReferralSourceAsync = async (
  abort: AbortController,
  contractId: number
): Promise<ReferralSourceResponse> => {
  const params = new URLSearchParams();
  params.set("contractId", `${contractId}`);
  return getApi<ReferralSourceResponse>(`/api/contract/referralsources?${params.toString()}`);
};

export default {
  fetchReferralSourceAsync,
};
